import PAY_LAKE_VENDOR from "./payLakeVendor";

export default PAY_LAKE_VENDOR;
